import React from "react";
import { Link } from "react-router-dom";
import { Button, Icon } from "@material-ui/core";
import { Spinner } from "react-bootstrap";
import clsx from "clsx";

class headerButton extends React.Component {
	render() {
		const { label, onClick, path, icone, disabled, link, loading } = this.props;
		return (
			<div data-tour={this.props.dataTour}>
				{path ? (
					<Link to={path}>
						<Button
							variant="contained"
							className="kt-button-adicionar"
							disabled={disabled}
						>
							{icone && (
								<Icon className="mr-2 kt-icons">{icone}</Icon>
							)}{" "}
							{label ? label : "Adicionar"}
						</Button>
					</Link>
				) : link ? (
					<div style={{ marginRight: "5px" }}>
						<Button
							variant="contained"
							className="kt-button-adicionar"
							disabled={disabled}
							href={link}
						>
							{icone && (
								<Icon className="kt-icons">{icone}</Icon>
							)}{" "}
							{label ? label : "Adicionar"}
						</Button>
					</div>
				) : (
					<div style={{ marginRight: "5px" }}>
						<Button
							variant="contained"
							className={`kt-button-adicionar`}
							disabled={disabled}
							onClick={onClick}
						>
							{
								loading ?
									<span className={clsx({
										"kt-spinner kt-spinner--right kt-spinner--sm kt-spinner--light mx-3": true
									})} />
									:
									icone && (
										<Icon className="kt-icons">{icone}</Icon>
									)
							}{" "}

							{loading ? "Aguarde..." : label ? label : "Adicionar"}
						</Button>
					</div>
				)
				}
			</div>
		);
	}
}

export default headerButton;
